import React, { ReactElement, ReactNode } from 'react'
import { Box, Button, Paper, Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const useStyles = makeStyles()(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    maxWidth: 480,
    display: 'flex',
    flexDirection: 'column',
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    width: 120,
    height: 120,
  },
  stepBar: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    padding: theme.spacing(2),
    width: '100%',
    height: '60px',
    borderRadius: 0,
    borderTop: `1px solid ${theme.palette.grey.grey06}`,
    display: 'flex',
    flexDirection: 'row-reverse',
  },
}))

interface Props {
  title: string
  body: string
  imageSource: string
  hasFooter?: boolean
  onClose?: () => void
  onBack?: () => void
  callToActionComponent?: ReactNode
}

const Screen: React.FC<Props> = ({ title, body, imageSource, hasFooter = false, onClose, onBack, callToActionComponent }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  const getFooterComponent = (): ReactElement | null =>
    hasFooter ? (
      <Paper className={classes.stepBar}>
        {onClose ? (
          <Button sx={{ mr: 2, minWidth: 100 }} color="primary" variant="contained" onClick={onClose}>
            {t('common.close')}
          </Button>
        ) : null}
        {onBack ? (
          <Button sx={{ mr: 2, minWidth: 100 }} color="primary" variant="outlined" onClick={onBack}>
            {t('common.back')}
          </Button>
        ) : null}
      </Paper>
    ) : null

  return (
    <Box className={classes.wrapper}>
      <Paper sx={{ m: 2 }} className={classes.container}>
        <Stack spacing={2}>
          <Typography variant="h4" sx={{ pt: 4 }}>
            {title}
          </Typography>
          <Typography variant="subtitle2" sx={{ pb: 2 }}>
            {body}
          </Typography>
          <Box className={classes.imageContainer}>
            <img src={imageSource} alt="" className={classes.image} />
          </Box>
        </Stack>
        {callToActionComponent}
      </Paper>
      {getFooterComponent()}
    </Box>
  )
}

export default Screen
